import React from 'react';
import axios from 'axios';

import * as Globals from './../Globals';


export default class TestCreator extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            subjects: [],
            date: "",
            gradingSystem: 1,
            questionNumber: 25,
            errorMessage: "",
            canSend: true
        }
    }

    componentDidMount() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.BASE_PATH + 'api/courses/' + this.props.courseID + '/lessons?test-subjs',
            {
                headers: {
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + cookie
                }
            }).then(response => {
            let subjects = [];
            response.data.data.map((subject) => {
                subject.subSubjects.forEach(item => item.superId = subject.id);
                subjects.push({
                    description: subject.description,
                    id: subject.id,
                    name: subject.name,
                    subSubjects: subject.subSubjects,
                    checked: false
                });
                return null;
            });
            this.setState({
                subjects: subjects
            });
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    createTest() {
        let currentDate = new Date();
        if (this.state.date < currentDate.toISOString().split('T')[0]) {
            this.setState({
                errorMessage: "Wählen Sie bitte ein Datum, dass nicht schon vergangen ist!"
            });
            return null;
        }
        let subjectIDs = [];
        this.state.subjects.forEach((subject) => {
            if (subject.checked) subjectIDs.push(subject.id);
            if (subject.subSubjects.length) {
                subject.subSubjects.forEach(i => {
                    if (i.checked) subjectIDs.push(i.id)
                })
            }
        });
        if (subjectIDs.length === 0) {
            this.setState({
                errorMessage: "Wählen Sie mindestens ein Fach aus!"
            });
            return null;
        }

        this.setState({canSend: false});
        this.forceUpdate();
        this.saveTest(subjectIDs);
    }

    saveTest(subjectIDs) {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.post(Globals.EL_PATH + 'course/' + this.props.courseID + '/test?Authentication=' + cookie, {
            EXPIRE_DATE: this.state.date,
            GRADING_SYSTEM: this.state.gradingSystem,
            QUESTION_NUMBER: this.state.questionNumber
        }).then((response) => {
            let testID = response.data.test_id;

            subjectIDs.map((subjectID, index) => {
                axios.post(Globals.EL_PATH + 'test/' + testID + '/subject?Authentication=' + cookie, {
                    SUBJECT_ID: subjectID
                }).then(() => {
                    if ((index + 1) === subjectIDs.length) {
                        axios.post(Globals.EL_PATH + 'test/' + testID + '/question?Authentication=' + cookie
                        ).then(() => {
                            this.props.sendCloseCreator(true);
                        }).catch((error) => {
                            this.props.CheckAuthError(error);
                        });
                    }
                }).catch((error) => {
                    this.props.CheckAuthError(error);
                });
                return null;
            });
        }).catch((error) => {
            this.props.CheckAuthError(error);
        });
    }


    handleCheckedChange(id, superId) {
        const subjects = this.state.subjects;
        let subject;
        if (superId) {
            subject = subjects.find(item => item.id === superId).subSubjects.find(item => item.id === id);
        } else {
            subject = subjects.find(item => item.id === id)
        }
        subject.checked = !subject.checked;
        if (subject.subSubjects.length) subject.subSubjects.forEach(s => s.checked = !s.checked);
        if (superId) {
            subjects.find(item => item.id === superId)
                .subSubjects.splice(subjects.find(item => item.id === superId).subSubjects.indexOf(subject), 1, subject);

        } else {
            subjects.splice(subjects.indexOf(subject), 1, subject);
        }
        this.setState({
            subjects: subjects,
            errorMessage: ""
        });
    }

    handleDateChange(event) {
        this.setState({
            date: event.target.value,
            errorMessage: ""
        });
    }

    handleQuestionNumberChanged(e) {
        if (e.target.value > 100) {
            this.setState({
                questionNumber: 100
            });
        } else if (e.target.value < 1) {
            this.setState({
                questionNumber: 1
            });
        } else {
            this.setState({
                questionNumber: e.target.value
            });
        }
    }

    changeGradingSystem(e) {
        this.setState({
            gradingSystem: e.target.value
        });
    }

    render() {
        return (
            <div>
                <h4 className="location-info no-margin-top margin-bottom-md text-center">Testerstellung</h4>
                {
                    this.state.subjects.map((subject) => {
                        return (
                            <div key={subject.id}>
                                <div className="well well-sm testCreator"
                                     style={{paddingTop: '5px', paddingBottom: '5px'}}>
                                    <label className="checkbox-label"
                                           style={{border: 'none', padding: '0 !important', margin: 0}}>
                                        <input className="customCheckbox" type="checkbox" checked={subject.checked}
                                               onChange={() => this.handleCheckedChange(subject.id)}/>
                                        <span className="label-text">{subject.name}</span>
                                    </label>
                                </div>
                                {
                                    subject.subSubjects.length ? subject.subSubjects.map((subSubject) =>
                                        <div key={subSubject.id} className="well well-sm testCreator"
                                             style={{paddingTop: '5px', paddingBottom: '5px', marginLeft: '15px'}}>
                                            <label className="checkbox-label"
                                                   style={{border: 'none', padding: '0 !important', margin: 0}}>
                                                <input className="customCheckbox" type="checkbox"
                                                       checked={subSubject.checked}
                                                       onChange={() => this.handleCheckedChange(subSubject.id, subSubject.superId)}/>
                                                <span className="label-text">{subSubject.name}</span>
                                            </label>
                                        </div>) : ''
                                }
                            </div>
                        );
                    })
                }
                <div className="form-group">
                    <label>Datum:</label>
                    <input className="form-control" type="date" value={this.state.date}
                           onChange={(e) => this.handleDateChange(e)}/>
                </div>
                <div className="form-group">
                    <label>Anzahl der Fragen <span className="questionRange">(5 - 100)</span></label>
                    <input type="number" min="1" max="100" className="form-control" value={this.state.questionNumber}
                           onChange={(e) => this.handleQuestionNumberChanged(e)}/>
                </div>
                <div className="form-group">
                    <label>Benotungssystem:</label>
                    <select id="gradingSystem" className="form-control" value={this.state.gradingSystem}
                            onChange={(e) => this.changeGradingSystem(e)}>
                        <option value="1">Einfaches Benotungssystem</option>
                        <option value="2">Benotungssystem mit Auszeichnung</option>
                        <option value="3">Schulnotensystem</option>
                    </select>
                </div>
                {(this.state.errorMessage !== "") ?
                    <div className="alert alert-danger no-margin margin-top-sm">{this.state.errorMessage}</div> : ""}
                {
                    (this.state.canSend) ?
                        <button className="btn btn-info margin-top-sm float-right creatorButtons firstCreatorButton"
                                type="button" onClick={() => this.createTest()}>Test erstellen</button> :
                        <button disabled
                                className="btn btn-info margin-top-sm float-right creatorButtons firstCreatorButton"
                                type="button">Test erstellen</button>
                }
                <button className="btn btn-danger margin-top-sm float-left creatorButtons" type="button"
                        onClick={() => this.props.sendCloseCreator(false)}>Abbrechen
                </button>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/admin/TestCreator.js